import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const AddNewClient: React.FC = () => {
  const { t } = useTranslation('client');
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/client/add');
  };

  return (
    <div>
      <p
        onClick={handleClick}
        className="bg-primary/300 text-white rounded-md py-2 px-4 cursor-pointer"
      >
        {t('graph.add_client')}
      </p>
    </div>
  );
};

export default AddNewClient;
